import { render } from "./FooterHome.vue?vue&type=template&id=78ff9b5c"
import script from "./FooterHome.vue?vue&type=script&lang=js"
export * from "./FooterHome.vue?vue&type=script&lang=js"

import "./FooterHome.vue?vue&type=style&index=0&id=78ff9b5c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__